import { useContext } from 'react';
import { useLocalStore } from 'mobx-react';
import { useConfig } from '@ibe/components';
import CmsGlobalElementsContext from '../Contexts/CmsGlobalElementsContext';
import CmsGlobalElementsService from '../Services/CmsGlobalElementsService';

function useGlobalElementsService(): CmsGlobalElementsService {
  const context = useContext(CmsGlobalElementsContext);
  const config = useConfig();
  const service: CmsGlobalElementsService = useLocalStore<CmsGlobalElementsService>(() => context);

  service.apiUrl = config.apiUrl;

  return service;
}

export default useGlobalElementsService;
